import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Flex, Typography } from 'antd';
const { Text } = Typography;
const RegLibProductStringDisplay = ({ data, additionalProp }) => {
    const [expanded, setExpanded] = useState(false);
    const [rows, setRows] = useState(3);
    return (
    // <Typography.Paragraph
    //   ellipsis={{
    //     rows,
    //     expandable: 'collapsible',
    //     expanded,
    //     onExpand: (_, info) => setExpanded(info.expanded)
    //   }}>
    _jsx(Flex, { vertical: true, gap: 5, children: data.map((sub, index) => (_jsxs(Text, { children: [_jsx(Text, { strong: true, children: sub.strLongDesc }, `${index}_${additionalProp}_head`), "(", sub.strProductTypes, ")", _jsx("br", {})] }, `${index}_${additionalProp}`))) }));
};
export default RegLibProductStringDisplay;
